export const BRAND = {
  name: "GROTALIS",
  descriptor: "The Private Cellar",
  tagline: "Where Every Bottle Is a Treasure.",
  domain: "grotalis.com",
};
